import React, { useState,useEffect } from 'react'
import portalServices from '../../../portalServices'
import AppHeader from '../../../components/AppHeader'
import OTPLoginPage from '../../../components/OTPLoginPage';
import moment from 'moment';
import AppFooter from '../../../components/AppFooter';


const NotificationDetails = ({details}) =>{
    return (
        <div className='card mb-2'>
            <div className='card-header'> <span className='fw-bold'>{details.title}</span> <sapn className="float-end">{moment(details.created_at).fromNow()}</sapn> </div>
            <div className='card-body'>
                {details.body}
            </div>
        </div>
    )
}


function NotificationListPage() {

    const [customerToken,setCustomerToken] =  useState(localStorage.customerToken);
    const [notificationList,setNotificationList] = useState([])

    const getNotificationList = () =>{
        if(customerToken){
            let payload = {
                customerToken : customerToken
            }
            portalServices.getNotificationList(payload).then(res=>{
                setNotificationList(res.data);
            }).catch(error=>{
            }).finally(()=>{
            })
        }
    }

    useEffect(()=>{
        getNotificationList();
    },[customerToken])

    return (
        <>
            <AppHeader/>
            <div className='container'>
                {
                    (customerToken === null || customerToken === undefined)?
                        <OTPLoginPage
                        setCustomerToken={setCustomerToken}
                        /> 
                    :
                    <div className='row mt-4'>
                        <div className='col-md-12'>
                            {notificationList && notificationList.map(notification=>
                                <NotificationDetails details={notification} />
                            )}
                        </div>
                    </div>
                }

            </div>
            <AppFooter/>
        </>
    )
}

export default NotificationListPage